import React, { Component } from "react";
import { Input } from "reactstrap";
import classNames from 'classnames';

const MIN_SCALE = 0;
const MAX_SCALE = 500;

export default class Range extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: `${props.value ?? 50}`,
      isShow: false,
    };
    const { min, max } = this.props;
    this.maxScale = max || MAX_SCALE;
    this.minScale = min || MIN_SCALE;
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.props;
    const { isShow } = this.state;

    if (!isShow && prevProps.value !== value) {
      this.setState({ value: `${value}` });
    }

    if (prevState.isShow && !isShow) {
      this.setState({ value: `${value}` });
    }
  }

  _handleChange(e, input) {
    const { handleChange, step } = this.props;
    const rawValue = e.target.value;

    if (input) {
      this.setState({ value: rawValue });
      if (rawValue === '') return;
    }

    if (+rawValue > this.maxScale || rawValue < this.minScale || !rawValue) return;
    const value = input
      ? +rawValue
      : Math.ceil(rawValue / step) * step;
    handleChange(value);
  }

  _handleBlur = () => {
    const { handleChange } = this.props;
    const { value } = this.state;
    const parsedValue = Number(value);

    if (value === '' || Number.isNaN(parsedValue)) {
      handleChange(this.minScale);
    } else if (parsedValue < this.minScale) {
      handleChange(this.minScale);
    } else if (parsedValue > this.maxScale) {
      handleChange(this.maxScale);
    } else {
      handleChange(parsedValue);
    }

    this.setState({ isShow: false });
  }

  render() {
    const { value, containerClass, step, handleChange, className } = this.props;
    const { isShow, value: inputValue } = this.state;
    return (
      <div className={classNames(className,
        {}, 'wrap-slide'
        )}
      >
        <div className="slidecontainer">
          <span
            onClick={() => {
              if (value === this.minScale) return;
              handleChange(+value - step);
            }}
            className="fas fa-window-minimize"
          ></span>

          <input
            type="range"
            min={this.minScale}
            max={this.maxScale}
            value={value}
            className="slider"
            onChange={(e) => this._handleChange(e)}
          />
          <i
            className="fas fa-plus"
            onClick={() => {
              if (value === this.maxScale) return;
              handleChange(+value + step);
            }}
          ></i>
          {isShow ? (
            <div className="wrap-input">
              <Input
                value={inputValue}
                min={this.minScale}
                max={this.maxScale}
                step={step}
                autoFocus
                type="number"
                onChange={(e) => this._handleChange(e, "input")}
                onBlur={this._handleBlur}
              />
            </div>
          ) : (
            <span
              className="ml-3 value"
              onClick={() => {
                this.setState({ isShow: true, value: `${value}` });
              }}
            >
              {value}%
            </span>
          )}
        </div>
      </div>
    );
  }
}
